var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { observer } from 'mobx-react';
import { ViewSmall, Viewport, ViewMedium, ViewLarge, ViewExtraLarge } from '@shared-ui/viewport-context';
import { UitkSkipLink } from 'uitk-react-skip-link';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { CoBrandBanner } from '@shared-ui/global-navigation-co-brand-banner';
import { Header } from '@shared-ui/global-navigation-header';
import { UitkSpacing } from 'uitk-react-spacing';
import { SharedUIHeaderLineOfBusiness, SharedUIHeaderMarketing } from '../../common/header/header';
import { HeaderLogoToolbar } from './header-logo-toolbar';
import { HeaderSecondaryNavigationBar } from './header-secondary-navigation-bar';
import { getHeaderData } from './gc-section-data';
import { HeaderNavExtendedToolbar } from './nav-lob-toolbar/header-nav-extended-toolbar';
import { HeaderRegion } from './templates/header-elements/header-region';
import { BSABanner } from './bsa-banner';
var GcDefaultHeader = /** @class */ (function (_super) {
    __extends(GcDefaultHeader, _super);
    function GcDefaultHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GcDefaultHeader.prototype.render = function () {
        var _a;
        var _b = this.props, analytics = _b.analytics, page = _b.page, l10n = _b.l10n, globalComponentsContext = _b.globalComponentsContext, context = _b.context, minimal = _b.minimal, simplified = _b.simplified, cobrandPosition = _b.cobrandPosition, fullWidth = _b.fullWidth;
        var siteHeaderClasses = [
            'site-header',
            fullWidth ? '' : 'global_navigation__header__default__max_width'
        ];
        var headerRegionClasses = ['no-stripe'];
        var subHeaderClasses = [
            'site-header',
            fullWidth ? '' : 'global_navigation__header__default__max_width'
        ];
        var headerData = getHeaderData(globalComponentsContext);
        var headerProps = {
            siteHeaderClasses: siteHeaderClasses,
            headerRegionClasses: headerRegionClasses,
            context: context,
            globalComponentsContext: globalComponentsContext,
            analytics: analytics,
            page: page,
            l10n: l10n,
            minimal: minimal,
            simplified: simplified,
            subHeader: null,
            showPrimaryNav: true,
            bsa: headerData.bsa,
            cobrandPosition: cobrandPosition
        };
        var pageName = page && page.pageName ? page.pageName : 'Unknown';
        var skipNavSection = headerData.skipNavText;
        var useSharedUIHeader = ((_a = globalComponentsContext === null || globalComponentsContext === void 0 ? void 0 : globalComponentsContext.header) === null || _a === void 0 ? void 0 : _a.useSharedUIHeader) || false;
        var skipText = skipNavSection !== undefined
            ? skipNavSection.sectionData[0].text
            : 'Skip to Main Content.';
        var skipMenuItems = [
            {
                attributes: {
                    role: 'menuitem',
                    tabindex: 0
                },
                className: 'uitk-list-item',
                href: '#main_content',
                label: skipText,
                typeAnchor: true
            }
        ];
        var gcNonSharedUIHeader = (React.createElement(UitkSpacing, { padding: {
                small: { inlinestart: 'six', inlineend: 'two' },
                medium: { inlinestart: 'six', inlineend: 'two' },
                large: { inlinestart: 'six', inlineend: 'two' },
                extra_large: { blockstart: 'one' }
            } },
            React.createElement(GCNonSharedUIHeader, { headerProps: headerProps, simplified: simplified, minimal: minimal, subHeaderClasses: subHeaderClasses })));
        var sharedUIHeader = function (lineOfBusiness, marketing) { return (React.createElement(Header, { lineOfBusiness: lineOfBusiness, pageName: pageName, marketing: marketing })); };
        var defaultHeader = function (lineOfBusiness, marketing) { return (useSharedUIHeader
            ? (sharedUIHeader(lineOfBusiness, marketing))
            : (React.createElement(Experiment, { name: "Shared_UI_Header" },
                React.createElement(ExperimentControl, null, gcNonSharedUIHeader),
                React.createElement(ExperimentVariant, { bucket: 1 }, sharedUIHeader(lineOfBusiness, marketing))))); };
        return (React.createElement(SharedUIHeaderLineOfBusiness.Consumer, null, // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        function (// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        lineOfBusiness) { return (React.createElement(SharedUIHeaderMarketing.Consumer, null, // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        function (// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        marketing) { return (React.createElement(React.Fragment, null,
            React.createElement(UitkSkipLink, { items: skipMenuItems }),
            cobrandPosition && React.createElement(ABControlledCoBrandBanner, { cobrandPosition: cobrandPosition }),
            minimal ? (gcNonSharedUIHeader) : (defaultHeader(lineOfBusiness, marketing)),
            React.createElement("div", { id: "main_content", className: "visually-hidden" }, l10n.beginMainContentText),
            cobrandPosition && React.createElement(HOBCoBrandBanner, { cobrandPosition: cobrandPosition }))); })); }));
    };
    GcDefaultHeader = __decorate([
        observer
    ], GcDefaultHeader);
    return GcDefaultHeader;
}(React.Component));
var GCNonSharedUIHeader = function (_a) {
    var headerProps = _a.headerProps, simplified = _a.simplified, minimal = _a.minimal, subHeaderClasses = _a.subHeaderClasses;
    return (React.createElement(React.Fragment, null,
        React.createElement(Viewport, null,
            React.createElement(ViewSmall, null,
                React.createElement(ApplicableHeader, __assign({}, headerProps))),
            React.createElement(ViewMedium, null,
                React.createElement(ApplicableHeader, __assign({}, headerProps))),
            React.createElement(ViewLarge, null,
                React.createElement(ApplicableHeader, __assign({}, headerProps, { simplified: true }))),
            React.createElement(ViewExtraLarge, null,
                React.createElement(ApplicableHeader, __assign({}, headerProps, { showPrimaryNav: simplified, subHeader: !simplified && !minimal ? (React.createElement("div", { className: subHeaderClasses.join(' ') },
                        React.createElement(HeaderNavExtendedToolbar, null))) : null }))))));
};
var ApplicableHeader = function (_a) {
    var headerRegionClasses = _a.headerRegionClasses, siteHeaderClasses = _a.siteHeaderClasses, context = _a.context, globalComponentsContext = _a.globalComponentsContext, analytics = _a.analytics, page = _a.page, l10n = _a.l10n, minimal = _a.minimal, simplified = _a.simplified, subHeader = _a.subHeader, showPrimaryNav = _a.showPrimaryNav, bsa = _a.bsa;
    return (React.createElement(React.Fragment, null,
        bsa && React.createElement(BSABanner, { bsa: bsa }),
        React.createElement(HeaderRegion, { className: headerRegionClasses.join(' ') },
            React.createElement(UitkSpacing, { margin: {
                    small: { block: 'one' },
                    medium: { block: 'three' },
                    large: { block: 'three' },
                    extra_large: minimal || simplified ? { block: 'three' } : { block: 'two' }
                }, padding: { inlinestart: 'six', inlineend: 'two' } },
                React.createElement("header", { className: siteHeaderClasses.join(' ') },
                    React.createElement(HeaderLogoToolbar, { globalComponentsContext: globalComponentsContext, analytics: analytics, page: page, l10n: l10n, minimal: !showPrimaryNav || minimal, simplified: simplified }),
                    React.createElement(HeaderSecondaryNavigationBar, { context: context, globalComponentsContext: globalComponentsContext, analytics: analytics, page: page, l10n: l10n, minimal: minimal })))),
        subHeader && (React.createElement(HeaderRegion, { className: "no-stripe" }, subHeader))));
};
var ABControlledCoBrandBanner = function (_a) {
    var cobrandPosition = _a.cobrandPosition;
    return (cobrandPosition === 'ABOVE_HEADER' && (React.createElement("div", null,
        React.createElement(CoBrandBanner, null))));
};
var HOBCoBrandBanner = function (_a) {
    var cobrandPosition = _a.cobrandPosition;
    return (cobrandPosition === 'BELOW_HEADER' && (React.createElement("div", null,
        React.createElement(CoBrandBanner, null))));
};
export { GcDefaultHeader };
//# sourceMappingURL=gc-default-header.js.map